var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('index-header',{attrs:{"title":"Account Profile"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-7"},[_c('h3',{staticClass:"m-b-30"},[_vm._v("Subscription")])]),_c('div',{staticClass:"column is-3"})])
}]

export { render, staticRenderFns }